import React, { createContext } from 'react';

import "./Accordion.css";

const CardContext = createContext();

export const Card = ({ children }) => {
    return <div className="card_container mb-2">{children}</div>;
};

const CardBody = ({ children }) => {

    return (
        <CardContext.Provider>
            <div className="card_body p-2">{children}</div>
        </CardContext.Provider>
    );
};

const CardText = ({ children }) => {
    return (
        <div className="card_text">
            {children}
        </div>
    );
};

Card.Body = CardBody;
Card.Text = CardText;

export default Card;